import type { FC, PropsWithChildren } from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';

interface Props extends PropsWithChildren {
    className?: string;
}

export const Wrapper: FC<Props> = ({ children, className }) => {
    return <div className={clsx(styles.wrapper, className)}>{children}</div>;
};

export const Paper: FC<Props> = ({ children, className }) => {
    return <div className={clsx(styles.paper, className)}>{children}</div>;
};

export const Title: FC<Props> = ({ children, className }) => {
    return <div className={clsx(styles.title, className)}>{children}</div>;
};

export const Subtitle: FC<Props> = ({ children, className }) => {
    return <p className={clsx(styles.subtitle, className)}>{children}</p>;
};
